import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { canAppPurchase } from "../utils/iap";
import { track } from "../utils/track";

/**
 * 옛 안드로이드 앱(2.1.0 전)에 업데이트 안내 (2026-10-18 사장님). 2.1.0 부터 앱 안에서 바로 구독할 수 있다.
 * 강제로 끄지 않고 '다음에'를 누르면 3일 동안 다시 안 뜬다.
 */
const KEY = "appUpdateNext";
const LATER = 3 * 24 * 60 * 60 * 1000;
const STORE = "https://play.google.com/store/apps/details?id=kr.chordscore.app";

const AppUpdateNotice: React.FC<{ blocked: boolean }> = ({ blocked }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (blocked || !/chordscore\/Android/.test(navigator.userAgent) || canAppPurchase()) return;
    try {
      if (Number(localStorage.getItem(KEY) || 0) > Date.now()) return;
    } catch (e) { /* 그냥 띄움 */ }
    const t = setTimeout(() => {
      track("app-update:show");
      setOpen(true);
    }, 1500);
    return () => clearTimeout(t);
  }, [blocked]);

  const later = () => {
    try { localStorage.setItem(KEY, String(Date.now() + LATER)); } catch (e) { /* 그냥 */ }
    setOpen(false);
  };

  if (!open) return null;
  return (
    <Modal
      open={open}
      onClose={later}
      title="새 버전이 나왔어요"
      content={
        <>
          앱을 업데이트하면 앱 안에서 바로 구독하고
          <br />
          새 기능(기타 반주·합주방)도 쓸 수 있어요.
          <br />
          <small>업데이트가 안 되면 앱을 지우고 플레이 스토어에서 다시 설치해 주세요.</small>
        </>
      }
      firstButtonLabel="업데이트"
      onClickFirstButton={() => {
        track("app-update:go");
        later();
        window.open(STORE, "_blank");
      }}
      secondButtonLabel="다음에"
      onClickSecondButton={later}
    />
  );
};

export default AppUpdateNotice;
